import { render, staticRenderFns } from "./briefcase-activity-log.html?vue&type=template&id=72b4189c&scoped=true&"
import script from "./briefcase-activity-log.js?vue&type=script&lang=js&"
export * from "./briefcase-activity-log.js?vue&type=script&lang=js&"
import style0 from "./briefcase-activity-log.scss?vue&type=style&index=0&id=72b4189c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4189c",
  null
  
)

export default component.exports